/**
 * The line under a section heading the owner left blank: the section's
 * generated line, except on a bold section, whose display heading stands
 * alone, and on a one-page site, which says only what the business's data
 * says. The generated lines are filler, and some claim what nothing on
 * record backs ("top-rated").
 * @param {string | undefined} variant The section's style.
 * @param {string} generated The line the section generates.
 * @param {boolean} [onePage] Whether the site is one page (see isOnePageSite).
 * @returns {string} The generated line, or "" on a bold section or a one-page site.
 */
const generatedSubheading = (variant: string | undefined, generated: string, onePage = false): string =>
  variant === "bold" || onePage ? "" : generated;

export { generatedSubheading };
